export const INTRO = 1;
export const INTEREST_QUESTIONS = 2;
export const PERSONALITY_INTRO = 3;
export const PERSONALITY_QUESTIONS = 4;
export const SKILL_INTRO = 5;
export const SKILL_QUESTIONS = 6;
export const LIFE_MEANING_INTRO = 7;
export const LIFE_MEANING_QUESTIONS = 8;
export const OUTRO = 9;


export const redPercentageColor = '#F23030'
export const orangePercentageColor = '#F27430'
export const yellowPercentageColor = '#FBBF24'
export const tealPercentageColor = '#02AAA4'
export const greenPercentageColor = '#22AD5C'


export const redProgressThreshold = 0
export const orangeProgressThreshold = 24
export const yellowProgressThreshold = 49
export const tealProgressThreshold = 74
export const greenProgressThreshold = 89


export const getColorByPercentage = (percentage: number) => {
    if (percentage >= greenProgressThreshold) {
      return greenPercentageColor;
    } else if (percentage >= tealProgressThreshold) {
      return tealPercentageColor;
    } else if (percentage >= yellowProgressThreshold) {
      return yellowPercentageColor;
    } else if (percentage >= orangeProgressThreshold) {
      return orangePercentageColor;
    } else {
      return redPercentageColor;
    }
  };
  

  export const getColorByCategory = (category: number) => {
    if (category == 5) {
      return greenPercentageColor;
    } else if (category == 4) {
      return tealPercentageColor;
    } else if (category == 3) {
      return yellowPercentageColor;
    } else if (category == 2) {
      return orangePercentageColor;
    } else {
      return redPercentageColor;
    }
  };
  


export function prependCoreUrl(text:string|null) {
    if(text==null)return "";
    const coreUrl = 'https://core.mycareer.mn';
    const updatedText = text.replace(/\/media\/upload/g, `${coreUrl}/media/upload`);
    return updatedText;
}